import { memo } from 'react'
import { TabContent } from 'components/Tab'
import IconInformation from 'remixicon/icons/System/information-line.svg?react'
import { OrderCargoServiceType } from 'schema'

import {
  MAX_HEIGHT_IN_CENTIMETER,
  MAX_LENGTH_IN_CENTIMETER,
  MAX_WEIGHT_CUSTOM,
  MAX_WIDTH_IN_CENTIMETER
} from '../OrderGuestCreateForm/constants'

interface IProps {
  className?: string
}

export const OrderServiceTypeInfoContent = memo<IProps>(function OrderServiceTypeInfoContent({ className }) {
  return (
    <div className={className} data-test-id="order--service--type--info--content">
      <TabContent tabId={OrderCargoServiceType.Id.CUSTOM}>
        <ul className="list-dash pl-5 marker:text-on-surface-variant">
          <li>вес до {MAX_WEIGHT_CUSTOM}&nbsp;кг;</li>
          <li>длина до {MAX_LENGTH_IN_CENTIMETER}&nbsp;см;</li>
          <li>ширина до {MAX_WIDTH_IN_CENTIMETER}&nbsp;см;</li>
          <li>высота до {MAX_HEIGHT_IN_CENTIMETER}&nbsp;см;</li>
          <li>упаковка силами заказчика.</li>
        </ul>
        <h2 className="mb-3 mt-4 text-title-md">
          Как правильно упаковать посылку по&nbsp;тарифу &laquo;Гибкий&raquo;?
        </h2>
        <p className="mb-2">
          <span className="text-title-sm">Недопустимы механические повреждения:</span> следы ударов,
          деформация/замятости, прорывы плёнки, дыры, нарушение целостности.
        </p>
        <p className="mb-2">
          <span className="text-title-sm">Недопустима возможность доступа к внутритарному содержимому:</span> надрывы
          пломб клиента, незапечатанные короба/мешки, следы вскрытия.
        </p>
        <p className="mb-2">
          <span className="text-title-sm">Недопустимо намокание упаковки:</span> следы влаги, деформация из-за
          воздействия влаги, потеря прочности, разрушение упаковки.
        </p>
        <p className="mb-2">
          <span className="text-title-sm">Хрупкий груз подлежит обязательной жёсткой упаковке:</span> изделия
          из&nbsp;стекла, оборудование со&nbsp;стеклянными элементами, кузовные автозапчасти, жидкие и текучие грузы в
          любой таре, оборудование и металлоконструкции без упаковки либо имеющие упаковку неправильной геометрической
          формы.
        </p>
        <div className="mt-6 grid grid-cols-[auto_1fr] items-start gap-x-4 rounded bg-surface-variant p-3">
          <IconInformation className="text-on-surface-variant" containerSize="nm" size="xs" />
          <div>
            При сдаче груза в&nbsp;упаковке, не&nbsp;соответствующей обеспечению безопасной транспортировки,
            ответственность за сохранность и&nbsp;товарный вид при выдаче получателю отправитель берёт на&nbsp;себя.
          </div>
        </div>
      </TabContent>
      <TabContent tabId={OrderCargoServiceType.Id.PALLET}>
        <ul className="list-dash pl-5 marker:text-on-surface-variant">
          <li>приём груза только на палетах заказчика;</li>
          <li>вес до 700&nbsp;кг;</li>
          <li>длина 120&nbsp;см;</li>
          <li>ширина 80&nbsp;см;</li>
          <li>высота до 210&nbsp;см.</li>
        </ul>
        <h2 className="mb-3 mt-4 text-title-md">
          Как правильно упаковать посылку по&nbsp;тарифу &laquo;Палета&raquo;?
        </h2>
        <p className="mb-2">
          Груз должен быть обмотан тройным слоем стретч-плёнки со&nbsp;всех сторон, в&nbsp;том числе сверху, взахлёст
          с&nbsp;поддоном.
        </p>
        <p className="mb-2">Нависание груза за&nbsp;края поддона не&nbsp;допускаются.</p>
      </TabContent>
    </div>
  )
})
